<!-- .block-features -->
<div class="block block-features block-features--layout--{{ layout }}">
    <div class="container">
        <!-- The owner's promises (the "home.trust" fragment), each with the icon that suits it. -->
        <div class="block-features__list" *ngIf="items?.length; else standard">
            <ng-container *ngFor="let item of items; let i = index; let last = last">
                <div class="block-features__item" [class.block-features__item--static]="!item.url" (click)="open(item)">
                    <div class="block-features__icon">
                        <app-icon [name]="icon(item, i)" size="48"></app-icon>
                    </div>
                    <div class="block-features__content">
                        <div class="block-features__title">{{ item.title }}</div>
                        <div class="block-features__subtitle" *ngIf="item.subtitle">{{ item.subtitle }}</div>
                    </div>
                </div>
                <div class="block-features__divider" *ngIf="!last"></div>
            </ng-container>
        </div>

        <ng-template #standard>
        <div class="block-features__list">
           
            <div class="block-features__item" >
                <div class="block-features__icon">
                    <app-icon name="fi-free-delivery-48" size="48"></app-icon>
                </div>
                <div class="block-features__content" (click)="router.navigate(['/products/'])">
                    <div class="block-features__title">{{ 'primehat-delivery-across-bangladesh' | t:'Delivery Across Bangladesh' }}</div>
                    <!-- A subtitle, as the other cards have, so the four titles stay level. No free-shipping badge:
                         the offer behind it (FreeShippingOffer) is a US-dollar line, and none is made here. -->
                    <div class="block-features__subtitle">{{ 'features-time-and-charge' | t:'Time and charge shown before you pay' }}</div>
                </div>
            </div>
            <div class="block-features__divider"></div>
            <div class="block-features__item" (click)="router.navigate(['/products/toprated'])">
                <div class="block-features__icon">
                    <app-icon name="fi-payment-security-48" size="48"></app-icon>
                </div>
                <div class="block-features__content">
                    <div class="block-features__title">{{ 'features-full-safety' | t:'100% Safety' }}</div>
                    <div class="block-features__subtitle">{{ 'features-secure-payments' | t:'Only secure payments' }}</div>
                </div>
            </div>
            <div class="block-features__divider"></div>
            <div class="block-features__item" (click)="router.navigate(['/products/latest'])">
                <div class="block-features__icon">
                    <app-icon name="new" size="48"></app-icon>
                </div>
                <div class="block-features__content">
                    <div class="block-features__title">{{ 'features-latest-products' | t:'Latest products' }}</div>
                    <div class="block-features__subtitle">{{ 'features-see-latest-products' | t:'See all latest products' }}</div>
                </div>
            </div>
            <div class="block-features__divider"></div>
            <div class="block-features__item" (click)="router.navigate(['/products/sale'])">
                <div class="block-features__icon">
                    <app-icon name="fi-tag-48" size="48"></app-icon>
                </div>
                <div class="block-features__content">
                    <div class="block-features__title">{{ 'features-hot-offers' | t:'Hot Offers' }}</div>
                    <div class="block-features__subtitle">{{ 'features-see-on-sale' | t:'See what is on sale' }}</div>
                </div>
            </div>
        </div>
        </ng-template>
    </div>
</div>
<!-- .block-features / end -->
